module.exports = __webpack_public_path__ + "assets/img/shu_01.39e8ebb5.png";